import { useSelector } from 'react-redux';
import { useGetJobsListingsQuery } from '@job-facets/redux/fetchApiSlice';

/**
 * Combined Redux hooks components to generate merged components
 */
function useArgsAddedQuery() {
	const jobFormsData = useSelector((state) => state.jobsFormInput);

	return useGetJobsListingsQuery(jobFormsData);
}

/**
 * Convert comma separated strings from url params and return an array
 * @param {string} string
 * @returns {array}
 */

function convertStringToArray(string) {
	if (!string) return [];

	return string.split(',');
}

export default useArgsAddedQuery;
export { convertStringToArray };
